/**
 * The About tab's section headings — Awards, Meet the Team — in the
 * overview's own voice: the line "Who we are" is set in, rather than a
 * numbered accordion row.
 */
export const ABOUT_SECTION_HEADING_CLASS =
    'm-0 font-sans font-medium tracking-[-0.025em] text-black max-md:text-[2rem] max-md:leading-[1.08] md:text-[3rem] md:leading-[1.05]';

/** The section's box: the accordion's gutters and cap, with room above and below. */
export const ABOUT_SECTION_CLASS = 'bg-ground max-md:px-5 md:px-[3.125rem]';
export const ABOUT_SECTION_CAP_CLASS =
    'mx-auto w-full max-w-[113.75rem] max-md:pt-10 max-md:pb-4 md:pt-[5rem] md:pb-[5rem]';
